import { useLocation } from 'react-router-dom';

import * as onboardingRoutes from 'src/app/onboarding/routes';
import Config from 'src/lib/config';
import { useShowSelfServeScaleUI } from 'src/lib/featureFlags';
import { setOverlayVisibleLocation } from 'src/lib/routing';

/**
 * If user is in the growth-show-self-serve-scale-ui flag, use the self-serve upgrade route/button text.
 * Otherwise, use the legacy upgrade route/button text.
 */
export const useUpgradeContext = () => {
  const location = useLocation();
  const showSelfServeScaleUI = useShowSelfServeScaleUI();

  return {
    upgradeRoute: showSelfServeScaleUI
      ? onboardingRoutes.selectPlan.definition
      : setOverlayVisibleLocation({
          location,
          overlayName: Config.modals.contactSalesToUpgrade,
        }),
    upgradeButtonText: showSelfServeScaleUI ? 'Change plan' : 'Request upgrade',
  };
};
